import classnames from 'classnames';
import createUseStyles from '@picsart/rc/create';
import { ReactNode, useMemo, memo, createElement } from 'react';

import {
  textSize, textWeight, textColor, TextSizeProps, TextWeightProps, TextColorProps,
} from './modes';

function styled(tagname: string) {
  return (...filters: any[]) => {
    const useStyles = createUseStyles({
      text: props => props,
    });
    return memo(({ children, className, ...props }: { children: ReactNode; className?: string }) => {
      const usedProps: string[] = [];
      const propsProxy = new Proxy(props, {
        get(target, prop) {
          usedProps.push(prop as string);
          // @ts-ignore
          return props[prop];
        },
      });
      const style = filters.reduce((result: Record<string, string>, filter) => ({ ...result, ...(filter(propsProxy) || {}) }), {});
      const classes = useStyles(style);
      const neededProps = {};
      for (const key in props) {
        if (!usedProps.includes(key)) {
          // @ts-ignore
          neededProps[key] = props[key];
        }
      }
      return createElement(tagname, {
        ...neededProps,
        className: classnames(classes.text, className),
      }, children);
    });
  };
}

interface IText extends TextSizeProps, TextWeightProps, TextColorProps {
  id?: string;
  tagType?: keyof typeof tagTypes;
  children: ReactNode;
  className?: string;
  target?: string;
  href?: string;
  rel?: string;
  onClick?: Function;
}

const tagTypes = {
  a: styled('a'),
  p: styled('p'),
  h1: styled('h1'),
  h2: styled('h2'),
  h3: styled('h3'),
  h4: styled('h4'),
  h5: styled('h5'),
  h6: styled('h6'),
  span: styled('span'),
};

const Text = ({ tagType = 'span', children, ...props }: IText) => {
  const Component = useMemo(() => tagTypes[tagType](textSize, textWeight, textColor), [tagType]);
  return (
    <Component {...props}>
      {children}
    </Component>
  );
};

export default memo(Text);
